import BanDeviceDialog from "../containers/banDialog";
import FilterTable from "./filterTable";
import React from "react";
import { complexColumn } from "./tableUtils";

const BanHistoryTable = (props) => {
  const columns = [
    {
      dataField: "eventDateTime",
      text: "Event time",
      sort: true,
      filter_: { type: "datetime" },
    },
    {
      dataField: "eventName",
      text: "Event name",
      sort: true,
      filter_: { type: "text" },
    },
    {
      dataField: "user.login",
      text: "User",
      sort: true,
      filter_: { type: "text" },
    },
    {
      dataField: "previous",
      text: "Previous values",
      filter_: { type: "text" },
    },
    {
      dataField: "info",
      text: "Info",
      filter_: { type: "text" },
    },
  ];

  const defaultSorted = [
    {
      dataField: "eventDateTime",
      order: "desc",
    },
  ];

  return (
    <FilterTable
      {...props}
      objectName="banHistory"
      data={props.history.map((histrec, i) => ({
        ...histrec,
        info: complexColumn(
          i < props.history.length - 1 ? props.history[i + 1].previousValues : histrec.bannedDevice,
          [{ fields: "banStatus", label: "Ban status" }],
          (value) => `${BanDeviceDialog.BanStatusCaptions[value]}`
        ),
        previous: complexColumn(
          histrec,
          [{ fields: "previousValues.banStatus", label: "Ban status" }],
          (value) => `${BanDeviceDialog.BanStatusCaptions[value]}`
        ),
      }))}
      columns={columns}
      defaultSorted={defaultSorted}
      noDataIndication="There are no ban history records"
    />
  );
};

export default BanHistoryTable;



// WEBPACK FOOTER //
// ./src/components/banHistoryTable.js